<template>
  
    <component1 ref='componentOne'></component1 >
  <div>
    <!-- navbar-->
    <nav class="navbar is-fixed-top" style="width:100%; height:12%;" role="navigation" aria-label="main navigation" aria-expanded="true">
      <div class="navbar-brand" >
        <a class="conteneur" style=  "margin-top:1%;" >
          <!-- logo fobware a gauche -->
          <img style="margin-bottom: 3%; margin-top:5%; " src="../../public/assets/img/logo.png" width="200" height="300">
        </a>
    <!-- Burger-->
      <a
      style="width:40px; height:40px; margin-right:15px;margin-top:4%;"
        role="button" 
        class="navbar-burger"
         aria-label="menu" 
         aria-expanded="false" 
         data-target="navbarBasicExample" 
         :class="{ 'is-active': mobileMenuActive }" 
         @click="mobileMenuActive = !mobileMenuActive"
      >
      <!-- representation burger -->
        <span style="width:28px; height:2px;margin-bottom:2px; " aria-hidden="true"></span>
        <span  style="width:28px; height:2px;margin-bottom:2px;" aria-hidden="true"></span>
        <span  style="width:28px; height:2px;margin-bottom:2px;" aria-hidden="true"></span>
      
      </a>
    </div>

  <!-- MENU MOBILE -->
  <div class="navbar-menu is-hidden-desktop" :class="{ 'is-active': mobileMenuActive }" style="width:100%;float:right; text-align:right; ">

    
        <div class="navbar-start" style="width:100%; flex-grow: 1; justify-content: center;">
          <div class="MenuMobile is-size-5">
          <!-- Items menu --> 
          <!-- ACCUEIL -->  
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#0')"><router-link class="navbar-item"   to="/"> ACCUEIL </router-link>  </span></a>
          <!--  A PROPOS  --> 
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#1')"><router-link class="navbar-item"    to="/AboutPage">  A PROPOS  </router-link></span></a>
          <!-- NOTRE EQUIPE --> 
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#2')"><router-link class="navbar-item"    to="/TeamPage"> NOTRE EQUIPE </router-link></span></a>
          <!-- NOS PRESTATIONS --> 
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#3')"><router-link class="navbar-item"    to="/ServicePage"> NOS PRESTATIONS </router-link> </span></a>
          <!-- NOS ENGAGEMENTS --> 
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#4')"><router-link class="navbar-item"   to="/SlidesPage"> NOS ENGAGEMENTS </router-link></span>  </a>
          <!-- ESPACE CLIENT --> 
          <a  class="navbar-item"  href="http://loc001.fobware.com:8081/eFOB_Customers_Portal"> ESPACE CLIENT</a>
          <!-- CONTACTS --> 
          <a  @click="mobileMenuActive = !mobileMenuActive"><span  v-on:click="scrollFix('#5')"><router-link class="navbar-item"  to="/contact"> CONTACTS </router-link></span></a>
          
        
          </div>
        </div>
  </div>

  <!-- MENU DESKTOP -->
 
    <div class="navbar-menu is-hidden-touch"  >

     
        <div class="navbar-start" style="width:100vh; flex-grow: 1; justify-content: center; ">
          <div class="Menu is-size-5 ">
          <!-- Items menu --> 
        
          <!-- ACCUEIL -->  
          <a><span   v-on:click="scrollFix('#0')" ><router-link  style="padding-top:1.5%;"    to="/"> ACCUEIL </router-link>  </span></a>
          <!--  A PROPOS  --> 
          <a ><span  v-on:click="scrollFix('#1')"> <router-link style="padding-top:1.5%;"  to="/AboutPage">A PROPOS</router-link></span></a>
          <!-- NOTRE EQUIPE --> 
          <a ><span  v-on:click="scrollFix('#2')"><router-link style="padding-top:1.5%;"    to="/TeamPage"> NOTRE EQUIPE </router-link></span></a>
          <!-- NOS PRESTATIONS --> 
          <a ><span  v-on:click="scrollFix('#3')"><router-link style="padding-top:1.5%;"    to="/ServicePage"> NOS PRESTATIONS </router-link> </span></a>
          <!-- NOS ENGAGEMENTS --> 
          <a><span   v-on:click="scrollFix('#4')"><router-link style="padding-top:1.5%;"    to="/SlidesPage"> NOS ENGAGEMENTS </router-link> </span> </a>
          <!-- CONTACTS --> 
          <a ><span  v-on:click="scrollFix('#5')"><router-link style="padding-top:1.5%;"  to="/contact"> CONTACTS </router-link></span> </a>
         
          </div>
        </div>
     </div>

        <!-- Icone à droite du menu --> 
         <div  class="navbar-end is-hidden-touch">
           <!-- Linkedin --> 
          <a  href="https://fr.linkedin.com/company/fobware-si" title="Linkedin"  target="_blank"><img  class="navbar-item" src="../../public/assets/img/linkedin.png" width="70" height="70"  ></a>
          <!-- Espace clients --> 
          <a href="http://loc001.fobware.com:8081/eFOB_Customers_Portal"  target="_blank" title="Espace client"><img  class="navbar-item" src="../../public/assets/img/user.png" width="72" height="70" ></a>
        
        </div>
   
  </nav>

  </div>
</template>


<script >


export default {
  name: "Menu",
 
  data() {
    return {
      mobileMenuActive: false,
    
    };
  },
mounted: function()
  {
    // From testing, without a brief timeout, it won't work.
    
     setTimeout(() => location.hash = this.$route.hash, 1);
    
  },
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang;
     
    },
    forceRerender() {
      location.reload()
    }
  
  }
  

};

</script>
<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300&display=swap');

.conteneur img{
   
    padding: 0 8px;
    height: 7.5vh;
    width:auto;
    background-position: center;
    background-size:cover;
    background-repeat: no-repeat;

}
.Menu{
  margin-top:2%;
  
 

}

.Menu a {
  padding: 0 20px;
  color:black;
  font-family: 'Montserrat', sans-serif;
 
  
}

img :hover{
  content:'texte';}
.MenuMobile{
  margin-top:2%;
}

.MenuMobile a {
  padding: 0 20px;
  color:black;
  font-family: 'Montserrat', sans-serif;
 
  
}
.navbar-end  {
  margin-top:1%;
  padding: 0 8px;
}


.Menu .router-link-exact-active {
border-top: 1px solid Black;
}

a.active:active {
border-top: 3px solid Black;

}
</style>